import { render, staticRenderFns } from "./MemorialHallMusic.vue?vue&type=template&id=6c83c3b6&scoped=true"
import script from "./MemorialHallMusic.vue?vue&type=script&lang=js"
export * from "./MemorialHallMusic.vue?vue&type=script&lang=js"
import style0 from "./MemorialHallMusic.vue?vue&type=style&index=0&id=6c83c3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c83c3b6",
  null
  
)

export default component.exports